import React, { FC, memo } from 'react';
import classNames from 'classnames';

import IconX from '@zvuk-b2b/react-uikit/ui/icons/X';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import type { AppliedAddressTagProps, AppliedAddressTagsProps } from './types';

import styles from '../index.module.scss';

const AppliedAddressTag: FC<AppliedAddressTagProps> = ({ tag, onRemove }) => (
  <button
    type="button"
    className={styles.appliedTag}
    aria-label={`${TEXTS.AUDIO_REPORT_ADDRESSES_REMOVE_TAG} ${tag.title}`}
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_APPLIED_TAG_REMOVE_BUTTON(tag.id)}
    onClick={() => onRemove(tag.id)}>
    <IconX className={styles.appliedTagIcon} />
    <span
      className={styles.appliedTagTitle}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_APPLIED_TAG(tag.id)}>
      {tag.title}
    </span>
  </button>
);

const AppliedAddressTags: FC<AppliedAddressTagsProps> = ({
  hiddenSelectedTagsCount,
  isExpanded,
  tags,
  onClear,
  onToggle,
  onRemove,
}) => {
  const isToggleVisible = hiddenSelectedTagsCount > 0;
  const toggleButtonText = isExpanded
    ? TEXTS.AUDIO_REPORT_ADDRESSES_HIDE_TAGS
    : TEXTS.AUDIO_REPORT_ADDRESSES_MORE_TAGS(hiddenSelectedTagsCount);
  const toggleButtonLabel = isExpanded
    ? TEXTS.AUDIO_REPORT_ADDRESSES_HIDE_TAGS
    : TEXTS.AUDIO_REPORT_ADDRESSES_SHOW_ALL_TAGS;

  return (
    <div
      className={styles.appliedTags}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_APPLIED_TAGS}>
      {tags.map((tag) => (
        <AppliedAddressTag
          key={tag.id}
          tag={tag}
          onRemove={onRemove}
        />
      ))}

      {isToggleVisible && (
        <button
          type="button"
          className={classNames(styles.appliedTag, styles.appliedTagsToggle)}
          aria-label={toggleButtonLabel}
          data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_APPLIED_TAGS_MORE_BUTTON}
          onClick={onToggle}>
          {toggleButtonText}
        </button>
      )}

      <button
        type="button"
        className={styles.clearTagsButton}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_CLEAR_TAGS_BUTTON}
        onClick={onClear}>
        {TEXTS.AUDIO_REPORT_ADDRESSES_CLEAR_TAGS}
      </button>
    </div>
  );
};

export default memo(AppliedAddressTags);
